import { CfSimpleDialog } from '../../../../cf-ui/dialogs/SimpleDialog/CfSimpleDialog';

type DiaryRevertDialogProps = {
  onClose: () => void;
  onSubmit: () => void;
  type: 'recipe' | 'ingredient' | 'menu';
};

export default function DiaryRevertDialog(props: DiaryRevertDialogProps): JSX.Element {
  const { onSubmit, onClose, type } = props;

  const title = `Restore ${type}`;
  const bodyText = `Are you sure you want to restore this deleted ${type}?`;

  return (
    <CfSimpleDialog
      isOpen
      title={title}
      primaryButtonProps={{
        children: 'Restore',
        onClick: onSubmit,
      }}
      secondaryButtonProps={{
        children: 'Cancel',
        onClick: onClose,
      }}
      onClose={onClose}
    >
      {bodyText}
    </CfSimpleDialog>
  );
}
